import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import '../../styles/Auth.css';
import { useAuth } from '../../context/AuthContext';
import { setAccessToken as setAxiosToken } from '../../api/axiosInstance';

function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [unverifiedUser, setUnverifiedUser] = useState(null);
  const { setAccessToken } = useAuth();
  const [stayLoggedIn, setStayLoggedIn] = useState(false);
  const [rememberDevice, setRememberDevice] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await axiosInstance.post('/auth/login', {
        identifier,
        password,
        stayLoggedIn,
        rememberDevice,
      });
      
      // Set the access token in both context and axios
      const { accessToken } = response.data;
      setAccessToken(accessToken);
      setAxiosToken(accessToken);
      
      console.log('Login successful, redirecting to home');
      navigate('/home');
    } catch (error) {
      console.error('Login error:', error);
      
      if (error.response?.data?.code === "EMAIL_NOT_VERIFIED") {
        setUnverifiedUser(identifier);
        setError(error.response.data.message);
      } else {
        setError(error.response?.data?.message || 'Login failed. Please try again.');
      }
    }
  };

  return (
    <div className="auth-container">
      <img src="/assets/images/logo-auth.png" alt="Logo" className="auth-logo" />
      <h1>trippin</h1>
      <div className="auth-card">     
        <form onSubmit={handleSubmit}>
          <input
            className="auth-input"
            placeholder="Email or Username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
          <input
            className="auth-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
          />
          <p className="forgot-container">
            <Link to="/forgot-password" className="forgot">forgot password?</Link>
          </p>
          <button className="auth-button" type="submit">Login</button>
          <div className="auth-checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={rememberDevice}
                onChange={(e) => setRememberDevice(e.target.checked)}
              />
              Remember this device
            </label>

            <label>
              <input
                type="checkbox"
                checked={stayLoggedIn}
                onChange={(e) => setStayLoggedIn(e.target.checked)}
              />
              Stay logged in
            </label>
          </div>
        </form>
        <p style={{ fontSize: "17px" }}>
          don't have an account? <Link to="/signup" className="auth-link">Sign Up</Link>
        </p>
        {unverifiedUser && (
          <div style={{ marginTop: '10px' }}>
            <p>Didn't get the email?</p>
            <button
              className="auth-button"
              onClick={async () => {
                try {
                  await axiosInstance.post('/auth/resend-verification', {
                    identifier
                  });
                  alert('Verification email sent!');
                } catch (err) {
                  alert('Failed to send email.');
                }
              }}
            >
              Resend Verification Email
            </button>
          </div>
        )}
        {error && <p className="auth-error">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
